import styled from 'styled-components';
import { StyledTextField } from '../../form-field.styled';

export const StyledPhoneInput = styled(StyledTextField)`
  .MuiInputBase-root {
    padding-left: 10px;
  }
`;
